import React, { useEffect, useRef } from 'react'
import { connect } from 'react-redux'
import { useTutorNoShow } from '../TutorNoShowContext'
import { DialogM } from '@common/components/alert/dialog/Dialog'
import { setMiniMode, setFocusedMode } from '@data/redux/actions/liveMode'

/**
 * Initial dialog shown when student joins and tutor is not present
 * Automatically switches to miniMode to show activity/exercises
 */
function InitialDialogComponent({ user, setMiniMode, setFocusedMode }) {
    const context = useTutorNoShow()
    const hasShownRef = useRef(false)

    // Guard: return null if provider is not present (e.g., trial sessions)
    if (!context) return null

    const { shouldShowInitialDialog, minutesSinceStart, tutorBusyElsewhere, announcedArrival } = context

    useEffect(() => {
        if (shouldShowInitialDialog && !hasShownRef.current) {
            hasShownRef.current = true

            const isEarlyArrival = minutesSinceStart < 0
            const meanwhile = user?.todo_activities?.length > 0
                ? "En attendant, travaille sur ton activité !"
                : "En attendant, tu peux commencer tes devoirs."

            // A tutor seen teaching their previous séance beats a delay they
            // announced earlier: it is what is happening now.
            const text2 = isEarlyArrival
                ? "Tu es un peu en avance ! Le tuteur devrait arriver à l'heure de début de la séance."
                : tutorBusyElsewhere
                    ? `Il arrive. ${meanwhile}`
                    : announcedArrival
                        ? `${announcedArrival}. ${meanwhile}`
                        : `Il ne devrait pas tarder. ${meanwhile}`
            const text1 = isEarlyArrival
                ? "Tu es en avance !"
                : tutorBusyElsewhere
                    ? "Ton tuteur termine sa séance précédente"
                    : "Ton tuteur n'est pas encore là"

            DialogM.show({
                champion: 'abou',
                variant: 'main',
                text1,
                text2,
                onPress: () => {
                    setMiniMode(true)
                    setFocusedMode(false)
                },
                onPressBack: () => {
                    setMiniMode(true)
                    setFocusedMode(false)
                },
            })
        }

        // Reset flag when dialog should no longer show
        if (!shouldShowInitialDialog && hasShownRef.current) {
            hasShownRef.current = false
        }
    }, [shouldShowInitialDialog, user, setMiniMode, setFocusedMode, tutorBusyElsewhere, announcedArrival])

    return null
}

const mapDispatchToProps = {
    setMiniMode,
    setFocusedMode,
}

export const InitialDialog = connect(null, mapDispatchToProps)(InitialDialogComponent)
